import React, { Component } from 'react';
import { Col, Row } from 'react-materialize';

export default class ChartEditorTitle extends Component {
    constructor(props){
        super(props);
        this.state = {
            editTitle:false,
            editSubtitle:false
        }
    }
    onChangeTitle(event){
        this.props.onChange({title:event.target.value});
    }
    onChangeSubtitle(event){
        this.props.onChange({subtitle:event.target.value});
    }
    render(){
        return <div className="ce-full-title-ct">
            <div style={{width:'100%',height:'40px',float:'left'}}>
            <Col l={12} m={12} s={12}>
                <input 
                    className="ce-chart-title"
                    placeholder="Enter a title"
                    value={this.props.title}
                    onChange={this.onChangeTitle.bind(this)}/>
            </Col>
            </div>
            <div style={{width:'100%',height:'25px',float:'left'}}>
            <Col l={12} m={12} s={12}>
                <input 
                    className="ce-chart-subtitle"
                    placeholder="Enter a subtitle"
                    value={this.props.subtitle}
                    onChange={this.onChangeSubtitle.bind(this)}/> 
            </Col>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/ChartEditorTitle.jsx